// Bulma variables, modify the scss variables if these change
// All these breakpoints are the upper value inclusive (mobile goes from 0 to 768, tablet from 769 to 1023)
export default {
    MOBILE: 768,
    TABLET: 1023
};
